// extracted by mini-css-extract-plugin
export default {"arrows":"SliderDesigners_arrows__ZaxWC"};